// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"checkbox_Wrapper__3Cvw5","isChecked":"checkbox_isChecked__1bOjY","disabled":"checkbox_disabled__2rq_p","Icon":"checkbox_Icon__l1Ky1"};